import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Logo } from '@/components/Logo/Logo';
import { MaintenanceBanner } from './MaintenanceBanner';
import { AppFooter } from './AppFooter';
import styles from './AppLayout.module.css';

export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={styles.shell}>
      <MaintenanceBanner />
      <header className={styles.topBar}>
        <Logo compact />
        <button
          type="button"
          className={styles.menuBtn}
          aria-label={menuOpen ? 'Menu sluiten' : 'Menu openen'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          ☰
        </button>
      </header>
      {menuOpen ? (
        <button
          type="button"
          className={styles.backdrop}
          aria-label="Menu sluiten"
          onClick={() => setMenuOpen(false)}
        />
      ) : null}
      <div className={styles.body}>
        <aside className={`${styles.sidebar} ${menuOpen ? '' : styles.sidebarHidden}`}>
          <Sidebar />
        </aside>
        <main className={styles.main} id="main-content">
          <Outlet />
          <AppFooter />
        </main>
      </div>
    </div>
  );
}
